module.exports = __webpack_public_path__ + "static/media/loginSVG.389c39fa.svg";